import React from 'react';
import styles from './HelpContainerLayout.module.css';

const HelpContainerLayout = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.container}>{children}</div>
);

export default HelpContainerLayout;
